import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SortConfig } from '../../core/interface/SortConfig';
import { PaginationConfig } from '../../core/interface/PaginationConfig';
import { debounceTime, distinctUntilChanged, Subject, takeUntil } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { SalesActivitiesService } from '../../core/services/sales-activities.service';
import { HouseSalesPerformance, SalesTypePerformance } from '../../core/models/list-sales-performance';

@Component({
  selector: 'app-sales-list',
  templateUrl: './sales-list.component.html',
  styleUrl: './sales-list.component.css'
})
export class SalesListComponent implements OnInit {

  isLoading = false;
  error = '';

  // Filters
  searchForm !: FormGroup;
  sortBy = '';
  startDate: string = '';
  endDate: string = ''
  selectedStatus: string = 'All';


  sortConfig: SortConfig = {
    column: '',
    direction: ''
  };

  paginationConfig: PaginationConfig = {
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0
  };

  searchTerm: string = '';

  private searchSubject = new Subject<string>();
  private destroy$ = new Subject<void>();

  ItemSalesType: SalesTypePerformance[] = [];
  ItemInHouseSales: HouseSalesPerformance[] = [];


  constructor(
    private salesServices: SalesActivitiesService,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute
  ) {

    this.setupSearchSubscription();

    this.searchForm = this.fb.group({
      searchTerm: ['']
    });
  }


  private setupSearchSubscription(): void {
    this.searchSubject.pipe(
      takeUntil(this.destroy$),
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(term => {
      // Update URL dan load data hanya jika ada term
      if (term.trim()) {
        this.updateUrlParams();
      }
      this.LoadHouseSalesPerformance(term);
    });
  }


  ngOnInit(): void {

    const startDate = localStorage.getItem('startDate')
    const endDate = localStorage.getItem('endDate')

    this.startDate = startDate ? startDate : '';
    this.endDate = endDate ? endDate : '';


    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        this.searchTerm = params['search'] || '';
        this.sortConfig.column = params['sortColumn'] || '';
        this.sortConfig.direction = params['sortDirection'] as 'ASC' | 'DESC' | '' || '';
        this.paginationConfig.currentPage = Number(params['page']) || 1;

        this.LoadHouseSalesPerformance(this.searchTerm);
      });

    // const paramsId = this.route.snapshot.paramMap.get('id');

    // this.route.queryParams.subscribe(params => {
    //   if (paramsId) {
    //     // this.showFloorDetails = true;
    //   }
    // });

    this.loadSalesType();
    this.LoadHouseSalesPerformance();

  }


  loadSalesType(): void {
    this.isLoading = true;

    this.salesServices.getSalesTypePerformance(
      this.startDate,
      this.endDate
    ).subscribe({
      next: (response) => {
        if (response && response.data) {
          // Memeriksa struktur respons sebelum mengassign
          this.ItemSalesType = response.data;
          this.isLoading = false;
        } else {
          this.error = 'Respons API tidak valid';
          this.ItemSalesType = [];
          this.isLoading = false;
        }
      },
      error: (error) => {
        let errorMessage = 'Error saat memuat data sales type performance: ';

        if (error.status === 200 && error.statusText === 'OK') {
          errorMessage += 'Error saat memproses format respons JSON';
        } else if (error.error instanceof ErrorEvent) {
          // Error dari sisi client
          errorMessage += `Error client: ${error.error.message}`;
        } else {
          // Error dari sisi server
          errorMessage += `Kode: ${error.status}, Pesan: ${error.message}`;
        }

        console.error(errorMessage, error);
        this.error = errorMessage;
        this.isLoading = false;
        this.ItemSalesType = [];
      }
    });



  }

  LoadHouseSalesPerformance(searchTerm?: any): void {
    this.isLoading = true;

    // console.log('ItemInHouseSales', this.ItemInHouseSales);

    this.salesServices.getHouseSalesPerformance(
      this.paginationConfig.currentPage,
      this.paginationConfig.itemsPerPage,
      searchTerm?.trim() || '',
      this.sortConfig.column,
      this.sortConfig.direction.toUpperCase() as 'ASC' | 'DESC',
      this.startDate,
      this.endDate
    ).subscribe({
      next: (response) => {
        if (response && response.data) {
          this.ItemInHouseSales = response.data;
          this.paginationConfig.totalItems = response.pagination.total_items;

          this.isLoading = false;
        } else {
          this.error = 'Respons API tidak valid';
          this.isLoading = false;
          this.ItemInHouseSales = [];
        }
      },
      error: (error) => {
        let errorMessage = 'Error saat memuat data house sales performance: ';

        if (error.status === 200 && error.statusText === 'OK') {
          errorMessage += 'Error saat memproses format respons JSON';
        } else if (error.error instanceof ErrorEvent) {
          errorMessage += `Error client: ${error.error.message}`;
        } else {
          errorMessage += `Kode: ${error.status}, Pesan: ${error.message}`;
        }

        console.error(errorMessage, error);
        this.error = errorMessage;
        this.isLoading = false;
        this.ItemInHouseSales = [];
      }
    });
  }

  onStatusChange(status: string): void {
    this.selectedStatus = status;
    this.paginationConfig.currentPage = 1; // Reset ke halaman 1 saat filter berubah
    // this.loadSalesData(this.searchTerm);
    this.updateUrlParams();
  }

  onSearchSalesType(event: KeyboardEvent): void {
    const target = event.target as HTMLInputElement;
    const term = target.value;

    // Update searchTerm dan trigger pencarian
    this.searchTerm = term;
    this.paginationConfig.currentPage = 1;
    this.searchSubject.next(term);

    // Jika input kosong, langsung clear search dan reset data
    if (!term.trim()) {
      const queryParams: Record<string, string | number | null> = {
        page: 1,
        search: null
      };

      // Jika ada sort config, pertahankan
      if (this.sortConfig.column && this.sortConfig.direction) {
        queryParams['sortColumn'] = this.sortConfig.column;
        queryParams['sortDirection'] = this.sortConfig.direction;
      }

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams,
        replaceUrl: true
      });

      this.LoadHouseSalesPerformance('');
    }
  }

  onSort(column: string): void {
    if (this.sortConfig.column === column) {
      this.sortConfig.direction = this.sortConfig.direction === 'ASC' ? 'DESC' : 'ASC';
    } else {
      this.sortConfig.column = column;
      this.sortConfig.direction = 'ASC';
    }

    this.paginationConfig.currentPage = 1; // Reset to first page on sort
    this.updateUrlParams();
    // this.loadSalesDetailList(this.searchTerm);
  }

  getSortIcon(column: string): string {
    // Jika bukan kolom yang sedang di-sort, tampilkan icon default
    if (this.sortConfig.column !== column) {
      return 'ri-expand-up-down-line'; // Remix icon untuk unsorted
    }

    // Jika kolom yang sedang di-sort
    if (this.sortConfig.direction === 'ASC') {
      return 'ri-arrow-up-line'; // Remix icon arrow up
    } else if (this.sortConfig.direction === 'DESC') {
      return 'ri-arrow-down-line'; // Remix icon arrow down
    }

    return 'ri-expand-up-down-line'; // Default fallback
  }

  private updateUrlParams(): void {
    const queryParams: any = {
      page: this.paginationConfig.currentPage
    };

    // Hanya tambahkan search param jika ada nilai
    if (this.searchTerm?.trim()) {
      queryParams.search = this.searchTerm.trim();
    } else {
      queryParams.search = null; // Hapus search param
    }

    if (this.sortConfig.column && this.sortConfig.direction) {
      queryParams.sortColumn = this.sortConfig.column;
      queryParams.sortDirection = this.sortConfig.direction;
    }

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams,
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  get totalPagesSalesType(): number {
    return Math.ceil(this.paginationConfig.totalItems / this.paginationConfig.itemsPerPage);
  }

  get pageNumbers(): number[] {
    const currentPage = this.paginationConfig.currentPage;
    const totalPages = this.totalPagesSalesType;

    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + 4);

    if (endPage - startPage < 4) {
      startPage = Math.max(1, endPage - 4);
    }

    return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
  }

  get displayRange(): { start: number; end: number; total: number } {
    const start = (this.paginationConfig.currentPage - 1) * this.paginationConfig.itemsPerPage + 1;
    const end = Math.min(
      start + this.paginationConfig.itemsPerPage - 1,
      this.paginationConfig.totalItems
    );

    return {
      start: this.paginationConfig.totalItems === 0 ? 0 : start,
      end,
      total: this.paginationConfig.totalItems
    };
  }

  clearSearch(): void {
    this.searchTerm = '';
    this.paginationConfig.currentPage = 1;
    this.updateUrlParams();
    this.LoadHouseSalesPerformance('');
  }

  clearAllFilters(): void {
    this.searchTerm = '';
    this.selectedStatus = 'All';
    this.sortConfig.column = '';
    this.sortConfig.direction = '';
    this.paginationConfig.currentPage = 1;
    this.updateUrlParams();
    this.LoadHouseSalesPerformance('');
  }

  onPageChangeSalesType(page: number): void {
    if (page < 1 || page > this.totalPagesSalesType || page === this.paginationConfig.currentPage) {
      return;
    }

    this.paginationConfig.currentPage = page;
    this.updateUrlParams();
    this.LoadHouseSalesPerformance(this.searchTerm);
  }


  onFirstPageSalesType(): void {
    this.onPageChangeSalesType(1);
  }

  onLastPageSalesType(): void {
    this.onPageChangeSalesType(this.totalPagesSalesType);
  }


  onPrevPageSalesType(): void {
    this.onPageChangeSalesType(this.paginationConfig.currentPage - 1);
  }

  onNextPageSalesType(): void {
    this.onPageChangeSalesType(this.paginationConfig.currentPage + 1);
  }

}
